import React from 'react'
import { IconSolidBgWhiteCheckmark } from '@mc/design-system'
import { withI18nContext } from '@mc/i18n'
import { usePromotion } from '@mc/promo-utils'
import { i18nInstance } from '../../i18n'
import { PromoCarryThroughText } from '../PromoCarryThroughText'

const QuizStickyFooterCopyComp = ({
  className = '',
}: {
  className?: string
}) => {
  const { isPromotionOn } = usePromotion({ isGift: false })

  if (!isPromotionOn) return null

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <IconSolidBgWhiteCheckmark
        className='mc-text--success mc-mr-4 mc-ml-0'
        style={{ flex: '0 0 auto' }}
        size='lg'
      />
      <p className='mc-text--bold'>
        <span className='d-flex d-md-none mc-text-small'>
          <PromoCarryThroughText />
        </span>
        <span className='d-none d-md-block'>
          <PromoCarryThroughText />
        </span>
      </p>
    </div>
  )
}

export const QuizStickyFooterCopy = withI18nContext(i18nInstance)(
  QuizStickyFooterCopyComp,
)
